import React from 'react'
import Top from '../../components/common/Top'
import Footer from '../../components/common/Footer'
import { Layout, Row, Input, Button, Col, Select, Slider, Pagination, Spin, Tooltip, message } from 'antd';
import { SearchOutlined, EnvironmentOutlined, CheckOutlined, HomeOutlined } from '@ant-design/icons';
import { getWebsiteProject } from '../../utils/api'
import { region } from '../../assets/javascript/region.js'
import { connect } from "react-redux";
import actionWays from '../../redux/actions';
const { Option } = Select;
const { Content } = Layout;

class Project extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            region: region[0].plate,
            minRent: 0,
            maxRent: 10000,
            projectName: '',
            layout: '',
            houseType: '',
            status: '',
            pageIndex: 1,
            pageSize: 6,
            projectAll: 0,
            projectList: [],
        }
    }
    componentDidMount() {
        const { query, state } = this.props.location;
        const filters = state && state.projectListFilters;
        if (filters) {
            this.setState({
                projectName: filters.searchKeyword !== undefined && filters.searchKeyword !== null ? filters.searchKeyword : '',
                layout: filters.layout !== undefined && filters.layout !== null ? filters.layout : '',
                status: filters.status !== undefined && filters.status !== null ? filters.status : '',
                houseType: filters.houseType !== undefined && filters.houseType !== null ? filters.houseType : '',
                minRent: typeof filters.minRent === 'number' ? filters.minRent : 0,
                maxRent: typeof filters.maxRent === 'number' ? filters.maxRent : 10000,
                pageIndex: typeof filters.pageIndex === 'number' && filters.pageIndex > 0 ? filters.pageIndex : 1,
            }, () => {
                this.getPageAll();
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    hash: this.props.location.hash,
                    search: this.props.location.search,
                });
            });
            return;
        }
        if (query && query.projectName) {
            this.setState({
                projectName: query.projectName,
                pageIndex: 1
            }, () => { this.getPageAll() });
        } else {
            this.getPageAll()
        }
    }
    getPage = async () => {
        let opts = {
            projectName: this.state.projectName,
            district: '宝山区',
            layout: this.state.layout,
            status: this.state.status,
            houseType: this.state.houseType,
            minRent: this.state.minRent,
            maxRent: this.state.maxRent,
            pageIndex: this.state.pageIndex - 1,
            pageSize: this.state.pageSize
        }
        console.log(opts);
        let projectList = await getWebsiteProject(opts)
        console.log(projectList);
        if (projectList.code === 0) {
            for (let i in projectList.data.pageContent) {
                projectList.data.pageContent[i].mediaUrl = projectList.data.pageContent[i].mediaUrl ? projectList.data.pageContent[i]?.mediaUrl.split(',') : ['']
                projectList.data.pageContent[i].thumbnail = projectList.data.pageContent[i].thumbnail ? projectList.data.pageContent[i]?.thumbnail.split(',') : ['']
            }
            this.setState({
                projectAll: projectList.data.pageTotal,
                projectList: projectList.data.pageContent,
            })
            console.log(this.state.projectList);
        } else {
            message.error(projectList.message)
        }
    }
    getRegion = () => {
        const region = this.state.region ? this.state.region : [];
        const children = [];
        for (let i in region) {
            children.push(
                <Option key={i} value={region[i]}>{region[i]}</Option>
            )
        }
        return children;
    }
    onRentRangeChange = (value) => {
        this.setState({
            minRent: value[0],
            maxRent: value[1],
        });
    }
    onAfterChange = (value) => {
        this.setState({
            minRent: value[0],
            maxRent: value[1],
            pageIndex: 1
        }, () => { this.getPageAll() })
    }
    setValue = (n, e) => {
        const value = e.target ? e.target.value : e;
        let obj = {};
        obj[n] = value
        this.setState({
            ...obj
        });
    }
    changeLayout = (value) => {
        this.setState({
            layout: value,
            pageIndex: 1
        }, () => { this.getPageAll() });

    }
    changeStatus = (value) => {
        this.setState({
            status: value,
            pageIndex: 1
        }, () => { this.getPageAll() });
    }
    changeHouseType = (value) => {
        this.setState({
            houseType: value,
            pageIndex: 1
        }, () => { this.getPageAll() });
    }
    getPageAll = () => {
        tapOnce(this.getPage, null, 500)
    }
    onChangeIndex = page => {
        this.setState({
            pageIndex: page,
        }, () => { this.getPageAll() });
    };
    getProjectDetail = (projectName, projectNo) => {
        const projectListFilters = {
            searchKeyword: this.state.projectName,
            layout: this.state.layout,
            status: this.state.status,
            houseType: this.state.houseType,
            minRent: this.state.minRent,
            maxRent: this.state.maxRent,
            pageIndex: this.state.pageIndex,
        };
        this.props.history.push({
            pathname: '/belows',
            query: { projectName: projectName, projectNo: projectNo },
            state: { projectListFilters },
        })
    }

    cityLists = () => {
        this.props.history.push({ pathname: '/citylist' })
    }
    render() {
        const { region, projectAll, projectList, projectName, minRent, maxRent, layout, status, houseType } = this.state;
        return (
            <Layout id='projectPage'>
                <Top />
                <Row >
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8 projectContent">
                        <div className="project-search">
                            <div style={{ height: '20px' }}></div>
                            <div className="form">
                                <div className="input">
                                    <Input placeholder="查找您的意向小区" value={projectName} onChange={this.setValue.bind(this, 'projectName')} />
                                    <div className="position" onClick={() => { this.getPageAll() }} ><SearchOutlined /><b style={{ fontWeight: 'normal' }}>开始找房</b> </div>
                                </div>
                                <Button onClick={() => { this.cityLists() }}><EnvironmentOutlined />{window.innerWidth < 576 ? null : '地图找房'}</Button>
                            </div>
                        </div>
                        <div className="project-screening">
                            <div className="title">条件筛选</div>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={9} xl={6}>
                                    <label>区域</label>
                                    <Select defaultValue="宝山区" style={{ width: 120 }} disabled>
                                        <Option value="宝山区">宝山区</Option>
                                    </Select>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={9} xl={6} style={{ marginBottom: '10px' }}>
                                    <label>板块</label>
                                    <Select value={layout} style={{ width: 150, }} color={'red'} onChange={(value) => { this.changeLayout(value) }}>
                                        <Option value="">全部</Option>
                                        {this.getRegion()}
                                    </Select>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={9} xl={6}>
                                    <label>状态</label>
                                    <Select value={status} style={{ width: 120 }} onChange={(value) => { this.changeStatus(value) }} >
                                        <Option value="">全部</Option>
                                        <Option value="1">有可租</Option>
                                        <Option value="0">已满租</Option>
                                    </Select>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={9} xl={6}>
                                    <label>户型</label>
                                    <Select value={houseType} style={{ width: 120 }} onChange={(value) => { this.changeHouseType(value) }} >
                                        <Option value="">全部</Option>
                                        <Option value="一">一室户</Option>
                                        <Option value="二">二室户</Option>
                                        <Option value="三">三室户</Option>
                                        <Option value="四">四室户</Option>
                                    </Select>
                                </Col>
                            </Row>
                            <div style={{ clear: 'both' }}></div>
                            <div className='changeZujin' style={{ display: 'flex', margin: '10px 0 30px 0', flexWrap: 'wrap' }}>
                                <label>租金</label>
                                <span style={{ color: '#bbb', width: '80px' }}>0 / <span style={{ color: '#3651a9' }}>{minRent}</span></span>
                                <span style={{ color: '#bbb', width: '220px', textAlign: 'right', marginLeft: '10px', display: 'none' }} className='zujinNone'><span style={{ color: '#3651a9' }}>{maxRent}</span> / 10000</span>

                                <Slider
                                    style={{ width: '300px' }}
                                    range
                                    max={10000}
                                    step={100}
                                    value={[minRent, maxRent]}
                                    onChange={this.onRentRangeChange}
                                    onAfterChange={this.onAfterChange}
                                    // tooltipVisible
                                    tooltipPlacement='bottom'
                                />
                                <span style={{ color: '#bbb', width: '120px', marginLeft: '20px' }} className='zujinBlock'><span style={{ color: '#3651a9' }}>{maxRent}</span> / 10000</span>
                                <Button type="primary" style={{ margin: '0 100px' }}>
                                    <div onClick={this.getPageAll}>搜索</div>
                                </Button>

                            </div>
                        </div>
                        <div className="project-content">
                            <div className="title">已匹配 {projectAll} 个项目</div>
                            <Row>
                                {projectList && projectList.length > 0 ?
                                    projectList.map((item, index) => {
                                        return (
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} key={index} onClick={() => { this.getProjectDetail(item.projectName, item.projectNo) }}>
                                                {/* <img src={item.mediaUrl[0]} /> */}
                                                <div className='project-images'>
                                                    <div style={{ backgroundImage: 'url(' + item.thumbnail[0] + ')', width: '100%', height: '100%', backgroundSize: '100%', borderRadius: '5px', backgroundRepeat: 'no-repeat' }}></div>
                                                </div>
                                                <div className="right" style={{ width: '300px' }}>
                                                    <div className="top">
                                                        <span style={{ fontSize: '24px', color: '#262626', }}>{item.projectName}</span>
                                                        <div>{item.minRent}<span> 元/月 起</span></div>
                                                    </div>
                                                    <div className="bottom">
                                                        <div><CheckOutlined /> 可租<Tooltip placement="topLeft" title={item.roomTypeCount}> <span style={{ color: 'rgba(26, 56, 156, 1)' }}>{item.kezuCount || 0} </span></Tooltip>套 </div>
                                                        <div className="shihu"><HomeOutlined /> {item.roomType && item.roomType.length > 0 ? item.roomType.split(',').map((item1, index1) => {
                                                            return (
                                                                <span key={index1}>{item1}室户{index1 + 1 == item.roomType.split(',').length ? '' : '/'}</span>
                                                            );
                                                        }) : <span className='noData'>暂无数据</span>}</div>
                                                        <div><EnvironmentOutlined /> {item.location}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })
                                    : <span className='noData'>暂无数据</span>}

                            </Row>
                            <Pagination current={this.state.pageIndex} onChange={this.onChangeIndex} defaultPageSize={6} total={projectAll} />
                            <div style={{ clear: 'both' }}></div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                </Row>
                <Footer />
            </Layout>
        )
    }

}
// 引入userLoginInfo
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Project)
